/* Pure Cartel — about page: editorial reveal (fade + rise on scroll into view) */
(function () {
  "use strict";
  var els = [].slice.call(document.querySelectorAll(".reveal"));
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    els.forEach(function (el) { el.classList.add("is-in"); });
    return;
  }
  function check() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = els.length - 1; i >= 0; i--) {
      var r = els[i].getBoundingClientRect();
      if (r.top < vh * 0.9 && r.bottom > 0) {
        els[i].classList.add("is-in");
        els.splice(i, 1);
      }
    }
    if (!els.length) {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    }
  }
  window.addEventListener("scroll", check, { passive: true });
  window.addEventListener("resize", check);
  window.addEventListener("load", check);
  check();
  /* ultimate safeguard: never leave content invisible */
  setTimeout(function () { els.forEach(function (el) { el.classList.add("is-in"); }); }, 2500);
})();
